import { WeatherTableContent } from '../WeatherTableContent/WeatherTableContent';
import { FC } from 'react';
import { orderedDefaultForecastParamCodes } from '@meteo/business/forecastParamCodes.utils';
import { WeatherCode } from '@meteo/types';
import { plcDayjs } from '@utils/date';
import { MetricsType, MetricsType24H, MOCK_STRING } from '../utils';

export interface WeatherTableMockProps {
  isLoading?: boolean;
}

const WeatherTableMock: FC<WeatherTableMockProps> = ({ isLoading }) => {
  const mockLength = 12;
  const dates = Array.from({ length: mockLength }, (_, k) => plcDayjs().add(k * 3, 'hour'));
  const weatherCodes = Array.from({ length: mockLength }, () => WeatherCode.ClearSkies);
  const metrics: MetricsType[] | MetricsType24H[] = orderedDefaultForecastParamCodes
    .filter((_, i) => i < 12)
    .map(code => ({
      data: Array.from({ length: mockLength }, () => MOCK_STRING),
      key: code,
    }));

  return (
    <WeatherTableContent
      coordinates={{ latitude: 1, longitude: 1 }}
      dates={dates}
      format15Days
      isChartEnabled={false}
      isLoading={isLoading}
      isSeeMoreEnabledDefault={true}
      metrics={metrics}
      timeframe="PT0S"
      weatherCodes={weatherCodes}
    />
  );
};

export { WeatherTableMock };
